import { CareerId } from '@common/const/catalog/career';
import { ROUTES_DEFAULT_CITY_ALIAS } from '@common/const/routes/defaultCity';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { Container } from '@cp/ds/src/components/container';
import { Link } from '@cp/ds/src/components/link';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { useClientWebResolver, useClientWebRouteParams } from '@cp/entities/clientWebRoutes';
import { FC, useCallback } from 'react';
import { Image } from '@cp/ds/src/components/image';
import { Box } from '@cp/ds/src/components/box';
import { useIsMobile } from '@cp/ds/src/hooks';
 
import BabyJpg from '../assets/baby.jpg';
 
import BabyWebp from '../assets/baby.jpg?&format=webp';

export const CatalogNotFound: FC<{ cityAlias?: string }> = ({ cityAlias }) => {
  const isMobile = useIsMobile();
  const routeResolver = useClientWebResolver();
  const { pageProps } = useClientWebRouteParams<ClientWebPage.Catalog>();
  const careerId = pageProps.careerId || CareerId.Nanny;
  const getLink = useCallback(
    (catalogType: CatalogItemType) =>
      routeResolver
        .resolve({
          pageProps: { catalogType, careerId },
          page: ClientWebPage.Catalog,
          cityAlias: cityAlias || ROUTES_DEFAULT_CITY_ALIAS,
        })
        .toString(),
    [careerId, cityAlias, routeResolver],
  );

  return (
    <Container maxWidth={900}>
      <Stack
        alignItems="center"
        direction="row"
        mb={{ xs: 6, md: 12 }}
        mt={{ xs: 5, md: 9 }}
        spacing={5}
        textAlign={isMobile ? 'center' : 'left'}
      >
        <Stack sx={{ flex: '1 1 0px' }}>
          <Typography sx={{ mb: 2 }} variant="h4">
            Что-то пошло не так!
          </Typography>
          <Typography sx={{ mb: 3 }}>Произошла ошибка. Пожалуйста, попробуйте обновить страницу.</Typography>
          <Link external href={getLink(CatalogItemType.Vacancy)} sx={{ mb: 1 }} target="_self">
            Поиск работы
          </Link>
          <Link external href={getLink(CatalogItemType.Resume)} target="_self">
            Поиск работников
          </Link>
        </Stack>
        {!isMobile && (
          <Box sx={{ width: 400 }}>
            <Image
              alt="Ребенек плачет"
              asset={{
                base: BabyJpg,
                webp: BabyWebp,
              }}
              height={394}
              sx={{ width: '100%', maxWidth: 300 }}
              width={300}
            />
          </Box>
        )}
      </Stack>
    </Container>
  );
};
